// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"iv_a bhe_rm","PhotoTitleEditForm__cancelBtn":"iv_b bhe_rq bhe_rp"};